import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  background: ${props => props.$bgColor || '#ffffff'};
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
  height: 96px;
  transition: all linear .2s;
  
  .card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    
    .card-title {
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      font-size: 13px;
      line-height: 1.3;
      padding-right: 8px;
    }
    
    .card-icon {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background: rgba(255,255,255,0.8);
      border-radius: 4px;
      img {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }
    }
  }

  .card-bottom {
    .card-counter {
      font-size: 24px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 1;
    }
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    transform: translateY(-2px);
  }
`
